export const Colors = {
  BLACK: '#000',
  GRAY_DARK: '#1A1A1A',
  GRAY_MEDIUM: '#333',
  RED: '#B34A4A',
  WHITE: '#E9E9E9',
  WHITE_LIGHTER: '#FCFBFA',
}
